import { AvailableLocale } from '@omnea-digital/toolbox'
import i18next, { Resource, ResourceLanguage, type i18n } from 'i18next'
import merge from 'lodash/merge'
import { defaultNS, i18nextFallbackResources } from '@omnea-app/packages/universal/i18n/i18nextFallbackResources'

export const getTranslationsJson = async (locale: AvailableLocale): Promise<Record<string, string>> => {
  try {
    const domain = process.env.TRANSLATION_HOST_DOMAIN
    if (!domain) return {}

    const latestTranslation = await fetch(`https://${domain}/${locale}/omnea-app.json`)
    const json = await latestTranslation.json()

    // S3 can return HTML if the file is not found
    if (latestTranslation.status >= 400 || !json || typeof json !== 'object') return {}
    return json
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const createI18nInstanceWithFallbackResources = (
  locale: AvailableLocale,
  latestTranslation: ResourceLanguage | undefined
): i18n => {
  const resources = merge(i18nextFallbackResources, latestTranslation)

  return createI18nInstance(locale, {
    [locale]: resources,
  })
}

export const createI18nInstance = (locale: AvailableLocale, resources: Resource): i18n => {
  const i18nextInstance = i18next.createInstance({
    resources,
    lng: locale,
    defaultNS,
    returnNull: false,
    returnObjects: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    initAsync: false,
  })

  // Initialise the i18n instance but don't wait for it
  i18nextInstance.init().catch((error) => {
    console.error(error)
  })

  return i18nextInstance
}
